(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["look-teaser"] && !Shopify.designMode) return;
  try {
    class LookTeaser extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setUp(), { once: true });
      } else {
        this.setUp();
      }
    }

    setUp() {
      const link = this.querySelector('a');
      const target = document.getElementById('complete-the-look');
      if (!link || !target) return;

      link.hidden = false;
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    }
  }

  if (!customElements.get('look-teaser')) {
    customElements.define('look-teaser', LookTeaser);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    function setUpProductCardGrow(card) {
    var media = card.querySelector('.product-card__media');
    var hoverWrap = card.querySelector('.product-card__hover-wrap');
    if (!media || !hoverWrap) return;

    function updateHeights() {
      var width = media.offsetWidth;
      var growHeight = width * (16 / 9);
      card.style.setProperty('--rest-height', width + 'px');
      card.style.setProperty('--grow-height', growHeight + 'px');
      card.style.setProperty('--grow-delta', (growHeight - width) + 'px');
    }

    updateHeights();
    window.addEventListener('resize', updateHeights);
  }

  document.querySelectorAll('.product-card').forEach(setUpProductCardGrow);

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.product-card').forEach(setUpProductCardGrow);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    connectedCallback() {
      const variantScript = this.querySelector('[data-variant-json]');
      this.variants = variantScript ? JSON.parse(variantScript.textContent) : [];
      this.hiddenInput = this.querySelector('[data-variant-id]');
      this.submitButton = this.querySelector('[data-add-to-cart]');
      this.submitText = this.querySelector('[data-add-to-cart-text]');
      this.priceWrapper = this.querySelector('[data-price]');
      this.optionButtons = this.querySelectorAll('[data-option-value]');

      const current = this.variants.find((variant) => variant.id === Number(this.hiddenInput.value));
      this.selected = current ? current.options.slice() : [];

      this.optionButtons.forEach((button) => {
        button.addEventListener('click', () => this.selectOption(button));
      });

      this.updateAvailability();
    }

    selectOption(button) {
      const index = Number(button.dataset.optionIndex);
      const value = button.dataset.optionValue;
      this.selected[index] = value;

      this.querySelectorAll('[data-option-index="' + index + '"]').forEach((sibling) => {
        const isActive = sibling === button;
        sibling.classList.toggle('is-selected', isActive);
        sibling.setAttribute('aria-pressed', String(isActive));
        if (isActive) {
          sibling.setAttribute('data-selected', '');
        } else {
          sibling.removeAttribute('data-selected');
        }
      });

      this.syncVariant();
      this.updateAvailability();
    }

    findVariant() {
      return this.variants.find((variant) =>
        variant.options.every((value, index) => value === this.selected[index])
      );
    }

    syncVariant() {
      const variant = this.findVariant();

      if (!variant) {
        this.submitButton.disabled = true;
        if (this.submitText) this.submitText.textContent = this.dataset.unavailableLabel;
        return;
      }

      this.hiddenInput.value = variant.id;

      const priceTemplate = this.querySelector('template[data-variant-price="' + variant.id + '"]');
      if (priceTemplate && this.priceWrapper) {
        this.priceWrapper.innerHTML = priceTemplate.innerHTML;
      }

      this.submitButton.disabled = !variant.available;
      if (this.submitText) {
        this.submitText.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
      }

      this.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant }, bubbles: true }));
    }

    updateAvailability() {
      this.optionButtons.forEach((button) => {
        const index = Number(button.dataset.optionIndex);
        const value = button.dataset.optionValue;
        const isAvailable = this.variants.some(
          (variant) => variant.options[index] === value && variant.available
        );
        button.classList.toggle('is-unavailable', !isAvailable);
      });
    }
  }

  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.slides = this.querySelectorAll('[data-gallery-slide]');
      this.lightboxSlides = this.querySelectorAll('[data-gallery-lightbox-slide]');
      this.dialog = this.querySelector('dialog');

      this.slides.forEach((slide) => {
        slide.addEventListener('click', () => this.openLightbox());
      });

      const prevButton = this.querySelector('[data-gallery-prev]');
      const nextButton = this.querySelector('[data-gallery-next]');
      if (prevButton) prevButton.addEventListener('click', () => this.step(-1));
      if (nextButton) nextButton.addEventListener('click', () => this.step(1));

      const closeButton = this.querySelector('[data-gallery-close]');
      if (closeButton && this.dialog) {
        closeButton.addEventListener('click', () => this.dialog.close());
      }

      if (this.dialog) {
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
      }

      document.addEventListener('variant:change', (event) => {
        const imageId = event.detail.variant.featured_image_id;
        if (!imageId) return;
        const slide = this.querySelector('[data-gallery-slide][data-image-id="' + imageId + '"]');
        if (slide) this.setActive(Number(slide.dataset.gallerySlide));
      });
    }

    step(direction) {
      const count = this.slides.length;
      if (!count) return;
      const current = Array.from(this.slides).findIndex((slide) => slide.classList.contains('is-active'));
      const nextIndex = (current + direction + count) % count;
      this.setActive(nextIndex);
    }

    setActive(index) {
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      this.lightboxSlides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
    }

    openLightbox() {
      if (this.dialog && typeof this.dialog.showModal === 'function') this.dialog.showModal();
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
